import { Container } from 'react-bootstrap';
import styled from 'styled-components';

import { Caption } from 'components/ui/Caption';
import { DiamondSeparator } from 'components/ui/Separators';

const CatalogSectionContainer = styled.section`
    padding-top: 120px;
    padding-bottom: 120px;

    background-color: var(--background);
`;

const BookCatalogContainer = styled.div`
    margin-bottom: 60px;
`;

const SchoolPackContainer = styled.div`
    margin-top: 60px;
`;

const HorizontalLine = styled.div`
    width: 100%;
    height: 1px;
    background-color: var(--primary-blue);
`;

function CatalogsSection(): JSX.Element {
    return (
        <CatalogSectionContainer id="catalogs">
            <Container>
                <BookCatalogContainer>
                    <Caption>
                        <h2>
                            Catálogo de <strong>Libros</strong>
                        </h2>
                        <DiamondSeparator />

                        <p>El catalogo de libros estará disponible pronto</p>
                    </Caption>
                    {/*<BooksCatalogWithOptions />*/}
                </BookCatalogContainer>
            </Container>
        </CatalogSectionContainer>
    );
}

export default CatalogsSection;
